/**
 * 1-jar GHK-Cu cart upgrade — bumps qty to 2 and optionally applies selling plan.
 */
(function () {
  'use strict';

  if (customElements.get('tava-cart-upgrade')) return;

  /**
   * Replaces cart drawer sections after a successful cart change.
   * @param {Object} parsedState - Shopify cart/change JSON response
   */
  function refreshCartDrawerSections(parsedState) {
    const sections = [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
    ];

    sections.forEach(({ id, section, selector }) => {
      const html = parsedState.sections && parsedState.sections[section];
      if (!html) return;

      const root = document.getElementById(id);
      if (!root) return;

      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const source = parsed.querySelector(selector);
      const target = root.querySelector(selector) || root;
      if (source) target.innerHTML = source.innerHTML;
    });

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.classList.toggle('is-empty', parsedState.item_count === 0);
      const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', () => cartDrawer.close());
    }

    const cartDrawerItems = document.querySelector('cart-drawer-items');
    if (cartDrawerItems) cartDrawerItems.classList.toggle('is-empty', parsedState.item_count === 0);
  }

  class TavaCartUpgrade extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-tava-upgrade-button]');
      if (!this.button || this.button.dataset.bound === 'true') return;
      this.button.dataset.bound = 'true';
      this.button.addEventListener('click', this.onUpgrade.bind(this));
    }

    /** Toggle CTA loading state */
    setLoading(isLoading) {
      if (!this.button) return;
      this.button.disabled = isLoading;
      this.button.setAttribute('aria-busy', isLoading ? 'true' : 'false');

      const defaultLabel = this.button.querySelector('[data-label-default]');
      const loadingLabel = this.button.querySelector('[data-label-loading]');
      if (defaultLabel) defaultLabel.hidden = isLoading;
      if (loadingLabel) loadingLabel.hidden = !isLoading;
    }

    /** Upgrade eligible line to 2 jars via cart/change */
    onUpgrade(event) {
      event.preventDefault();
      if (this.button.disabled) return;

      const line = parseInt(this.dataset.line, 10);
      if (!Number.isFinite(line)) return;

      const payload = {
        line,
        quantity: 2,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      };

      const sellingPlan = this.dataset.sellingPlan;
      if (sellingPlan) payload.selling_plan = parseInt(sellingPlan, 10);

      this.setLoading(true);

      fetch(`${routes.cart_change_url}`, {
        ...fetchConfig(),
        body: JSON.stringify(payload),
      })
        .then((response) => response.text())
        .then((text) => {
          const parsedState = JSON.parse(text);
          if (parsedState.errors) throw new Error(parsedState.errors);

          refreshCartDrawerSections(parsedState);

          if (typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'tava-cart-upgrade',
              cartData: parsedState,
              variantId: this.dataset.variantId,
            });
          }

          const liveRegion =
            document.getElementById('CartDrawer-LiveRegionText') ||
            document.getElementById('cart-live-region-text');
          if (liveRegion) {
            liveRegion.setAttribute('aria-hidden', 'false');
            setTimeout(() => liveRegion.setAttribute('aria-hidden', 'true'), 1000);
          }
        })
        .catch(() => {
          const errors =
            document.getElementById('CartDrawer-CartErrors') || document.getElementById('cart-errors');
          if (errors) errors.textContent = window.cartStrings?.error || 'Unable to update cart.';
        })
        .finally(() => this.setLoading(false));
    }
  }

  customElements.define('tava-cart-upgrade', TavaCartUpgrade);
})();
